import {Pipe, PipeTransform} from "@angular/core";
import {LoginService} from "../../login/login.service";
import {UsuariosModel} from "../../usuarios/usuarios.model";

@Pipe({
  name: 'moeda'
})
export class MoedaPipe implements PipeTransform {

  private userInfo = new UsuariosModel;

  constructor(private loginService: LoginService) {

    loginService.getUserInfo().subscribe(
      res => {
        this.userInfo = res;
      },
      error => {
        this.loginService.trataErro(error.json());
      });

  }

  transform(value, iso:any = 'BRL') {

    if(!value){
      return '';
    }

    return new Intl.NumberFormat(this.userInfo.idioma, {style: 'currency', currency: iso}).format(value);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/moeda.pipe.ts